import {ViewEncapsulation} from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { MatDialog } from '@angular/material/dialog';
import { DiganosisModel } from 'src/app/models/DiganosisModel';
import { CancerTreatmentModel } from 'src/app/models/CancerTreatmentModel';
import { CancerTreatmentService } from 'src/app/services/CancerTreatmentService';

@Component({
  selector: 'app-medication-plan',
  templateUrl: './medication-plan.component.html',
  styleUrls: ['./medication-plan.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MedicationPlanComponent implements OnInit {
  patientcode = '' ;
  Patientname = '';
  trdate = '2024-01-01' ;
  trtime = '2024-01-01' ;
  trlocation = '' ;
  trtype = '' ;
  trkind = '' ;
  trcycleno = '' ;
  trdayscycle = '' ;
  trnotes = '' ;
  trstartdate = '2024-01-01' ;
  trenddate = '2024-01-01' ;
  trdose = 0 ;
  trfrac = 0 ;
  trdosefrac = 0 ;
  userid = '' ;
  username = '' ;
  trconsultant = '';
  cancertreatmentList:CancerTreatmentModel[]=[];

  constructor(private dialogref: MatDialog,  public storage: LocalStorageService,
    public diganosis : DiganosisModel,
    public cancertreatmentService : CancerTreatmentService,) { }

  ngOnInit(): void {
        console.log("A7A0",this.Patientname)
        this.patientcode = this.storage.retrieve('stgPatientCode');
        this.Patientname = this.storage.retrieve('stgPatientName');
        this.trdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');

        this.RetriveCancerTreatment();
  }
  RetriveCancerTreatment(){

              this.cancertreatmentList = [];
               this.cancertreatmentService.getCancerTreatmentPatient(this.patientcode).subscribe((data: CancerTreatmentModel[]) => {
                  for (let i = 0; i < data.length; i++) {
                    this.cancertreatmentList[i] = data[i];
                    var notes =  this.cancertreatmentList[i].trnotes;


                    this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en');

                    if (data[i].trtype =='1' ){
                      this.cancertreatmentList[i].trtype ='Chemotherapy';
                      this.cancertreatmentList[i].trkind ='Regimen :' + data[i].trkind;
                      this.cancertreatmentList[i].trcycleno ='Cycle No. :' + data[i].trcycleno;

                    } ;


                  }
                })
  }
  openDialog(){
    
  }
  EditDecision(item :CancerTreatmentModel){

  }
  MessegeDelete(item :CancerTreatmentModel){

  }
}
